export class AddContactToFavoritesInput {
    contatId: number;
    userId: number;
    confirmAdd: boolean;
}
